export default "__VITE_ASSET__HWbFyg1vBlVJZBOk$HMBAQ__"